import SHImgUpload from './src/imgs.vue';


/**
 * 图片上传
 */

/* istanbul ignore next */
SHImgUpload.install = function(Vue) {
  Vue.component('sh-img-upload', SHImgUpload);
};
export default SHImgUpload;


// WEBPACK FOOTER //
// ./src/components/base/view/cmps/upload/imgs/index.js